var Helper = {
  set_cookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  },

  get_cookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  },

  array_unique(a) {
    var seen = {};
    var out = [];
    var len = a.length;
    var j = 0;
    for (var i = 0; i < len; i++) {
      var item = a[i];
      if (seen[item] !== 1) {
        seen[item] = 1;
        out[j++] = item;
      }
    }
    return out;
  },

  getTemplate(view, data) {
    if (
      view === null ||
      view === undefined ||
      data === null ||
      data === undefined
    ) {
      return;
    }
    var variables = view.split(/\$\{(.+?)\}/g);
    variables.map(function (i, e) {
      if (data[variables[e]]) {
        variables[e] = data[variables[e]];
      } else if (typeof data[i] != "undefined") {
        variables.splice(variables.indexOf(i), 1);
      }
      return variables;
    });
    return variables.join("");
  },
};
